module.exports = __webpack_public_path__ + "img/class2.2855e04d.png";